import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import CurriculumManagementAdmin from "./CurriculumManagementAdmin";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

createRoot(document.getElementById("ahg-curriculum-management-admin")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<CurriculumManagementAdmin />
		</ThemeProvider>
	</StrictMode>
);
